export function checkToken(token) {
  if (typeof token === 'string') {
    const parts = token.split('.');
    return parts.length === 3; // A valid JWT has three parts
  }
  return false;
}